export const useMyLocation = () => {
  const getUserCurrentCoords = async () => {
    const permission = await navigator.permissions.query({name: 'geolocation'})
    if (permission.state === 'denied') {
      console.error("Client doesn't have geolocation permission")
      return null
    }

    try {
      const pos: GeolocationPosition = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: false,
          maximumAge: 0,
          timeout: 5000,
        })
      })

      return {
        lng: pos.coords.longitude,
        lat: pos.coords.latitude,
      }
    } catch (e) {
      console.error("Error during getting user's coordinates")

      return null
    }
  }

  return {getUserCurrentCoords}
}
